import React from 'react';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';

const ConfirmModal=({handleConfirm, handleCancel, message, confirmType = 'submission'}) => {
  const getConfirmText = () => {
    if (confirmType === 'submission') {
      return 'Confirm Submission';
    }
    const capitalizedType = confirmType.charAt(0).toUpperCase() + confirmType.slice(1);
    return `Confirm ${capitalizedType}`;
  };

  return (
    <div>

      <DialogTitle id="responsive-dialog-title">{message}</DialogTitle>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
            Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" autoFocus>
            {getConfirmText()}
        </Button>
      </DialogActions>

    </div>
  );
}

ConfirmModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  message: PropTypes.string,
  confirmType: PropTypes.string
}
export default ConfirmModal;
